import constants from '@/constants';
const encryptedMarketplaceId = constants?.ENCRYPTED_MARKETPLACE_ID;
const formatTimestamp = constants.formatTimestamp;
import {
  getNewCustomerPromotions,
  getPromotionInfosByPromotionIds,
  getCustomerActualPurchase
} from '@/models/api/promotionApi.js';
import {
  PROMOTION_REDEEMED_STATUS,
  getKeywordHighlightPart,
  getCouponRightText
} from './config';
import { Bridge } from '@/utils/bridge';
import { ref } from 'vue';
import { i18n } from '@/local/index';
import { isLoginAuthenticated } from '@/utils/common';

const { t } = i18n.global;
export const couponsDataFun = () => {
  const activeStatus = ref(PROMOTION_REDEEMED_STATUS.REDEEMED);
  const highlightCouponData = ref([]); // Currently highlighted coupon data
  const allCouponData = ref([]); // Collection of new customer coupon data and promotional coupon data
  const newCustomerCouponData = ref([]); // New customer promotion data
  const referralCoustomerCouponData = ref([]); // Promotional coupon data
  const isLoad = ref(false);
  const wrapperLoading = ref(true);
  const getNewPromotionInfos = async requestData => {
    // get new customer promotion details
    const { data } = await getPromotionInfosByPromotionIds(requestData);
    if (
      !data ||
      !data?.miniAppPromotionList ||
      !data?.miniAppPromotionList.length
    ) {
      return;
    }
    newCustomerCouponData.value.forEach((item, index) => {
      Object.assign(item, data.miniAppPromotionList[index]);
      item.priceText = getKeywordHighlightPart(item);
      item.description = item.optimizedShortMerchandisingMessage;
      item.requirement = t('common.newCustomerCoupon');
      item.isNewCustomerCoupon = true;
      item.termOfValidity = `${formatTimestamp(
        item.startDate,
        'date',
        '.'
      )} - ${formatTimestamp(item.endDate, 'date', '.')}`;
      item.buttonText = getCouponRightText(item.status);
    });
  };
  const getNewCustomerPromotionsPromise = async () => {
    if (!(await isLoginAuthenticated(false))) return;
    // Here, we only get promotion summary.We need to call getNewPromotionInfos to get more detailed information of these promotions
    const { accessToken: token } = await Bridge.callFnVal('getAccessToken', {});
    const {
      data: { hasActualPurchase }
    } = await getCustomerActualPurchase();
    const { data } = await getNewCustomerPromotions(
      {
        encryptedMarketplaceId
      },
      { token }
    );
    if (!data || !data?.promotions || !data?.promotions.length) return;
    // If the current user has already placed an order, New customer coupons cannot be claimed at
    newCustomerCouponData.value = hasActualPurchase
      ? data.promotions.filter(
          item => item.status !== PROMOTION_REDEEMED_STATUS.ACTIVE
        )
      : data.promotions; // Voucher ID information
    let promotionIds = [];
    promotionIds = data.promotions.map(item => item.promotionId);
    await getNewPromotionInfos(promotionIds);
  };

  const handleHighlightCouponData = () => {
    // Process the currently highlighted coupon data
    allCouponData.value = []
      .concat(newCustomerCouponData.value)
      .concat(referralCoustomerCouponData.value);
    if (!allCouponData.value.length) {
      isLoad.value = false;
      wrapperLoading.value = false;
      return;
    }
    switch (activeStatus.value) {
      case PROMOTION_REDEEMED_STATUS.REDEEMED: // Can be used
        highlightCouponData.value = allCouponData.value.filter(
          i =>
            i.status === PROMOTION_REDEEMED_STATUS.REDEEMED ||
            i.status === PROMOTION_REDEEMED_STATUS.ACTIVE
        );
        break;
      case PROMOTION_REDEEMED_STATUS.USED: // Used
        highlightCouponData.value = allCouponData.value.filter(
          i => i.status === PROMOTION_REDEEMED_STATUS.USED
        );
        break;
      default: // Expired
        highlightCouponData.value = allCouponData.value.filter(
          i => i.status === PROMOTION_REDEEMED_STATUS.EXPIRED
        );
    }
    isLoad.value = false;
    wrapperLoading.value = false;
  };
  const getNcAndRcPromotionsPromise = async () => {
    // get new customer promotion and referral customer promotion data
    wrapperLoading.value = true;
    await getNewCustomerPromotionsPromise();
    handleHighlightCouponData();
  };
  return {
    handleHighlightCouponData,
    getNcAndRcPromotionsPromise,
    getNewCustomerPromotionsPromise,
    getNewPromotionInfos,
    activeStatus,
    highlightCouponData,
    allCouponData,
    newCustomerCouponData,
    referralCoustomerCouponData,
    isLoad,
    wrapperLoading
  };
};
